import React from "react";

export default function ExternalRedirect(props) {
  window.location.href = props.to;
  return <div></div>;
}
